module.exports = __webpack_public_path__ + "static/img/showpic2.f8e50c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/showpic2.png
// module id = leqR
// module chunks = 37